import { render, staticRenderFns } from "./ConversationApiCall.vue?vue&type=template&id=71dfddf4&"
import script from "./ConversationApiCall.vue?vue&type=script&lang=js&"
export * from "./ConversationApiCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports